import {create} from 'zustand'
import {ExportJob} from '@/features/exports/types'

/**
 * Holds the export job currently announced in the popover anchored to the exports toggle
 * (replacing the transient toast). The popover renders its content from the job's `status`:
 * `pending`/`processing` → "in elaborazione", `ready` → download CTA, `failed` → failure reason.
 *
 * Set by the enqueue flow (after the dialog "flies" into the toggle, as a pending job) and by the
 * socket listener when the job turns ready/failed; cleared when the user dismisses it (X),
 * downloads, or opens the drawer.
 */
interface ExportAnnouncementState {
    job: ExportJob | null
    announce: (job: ExportJob) => void
    dismiss: () => void
}

export const useExportAnnouncementStore = create<ExportAnnouncementState>(set => ({
    job: null,
    announce: job => set({job}),
    dismiss: () => set({job: null})
}))
